import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { userActiveStep } from 'utils/constants/account/user-status';
import { lazy } from 'utils/generic/lazy';
import { useFetchAccountParams } from 'newhooks/account/useFetchAccountParams';
import { getSumSubModalOpen, getUser } from 'store/selectors/user-data';

const { SumSubKYCVerification } = lazy(
  () =>
    import(
      /* webpackChunkName: "sum-sub-KYC-verification" */ 'newcomponents/Shared/account/SumSubKYCVerification'
    )
);

export const SumSubKYCVerificationCheck = () => {
  const sumSubModalOpen = useSelector(getSumSubModalOpen);
  const { accountParams } = useFetchAccountParams();
  const user = useSelector(getUser);

  const checkSumSubKYCVerification =
    (!Number(accountParams?.sumSubWithdrawalAction) &&
      user.active_step === userActiveStep.USER_ACTIVE_STEP_VALUE_37 &&
      user.active_step_state ===
        userActiveStep.USER_ACTIVE_STEP_STATE_VALUE_5) ||
    sumSubModalOpen;

  if (!checkSumSubKYCVerification) {
    return null;
  }

  return (
    <Suspense>
      <SumSubKYCVerification />
    </Suspense>
  );
};
